"use client";

import { useState } from "react";
import { Box, Badge } from "@mantine/core";
import Link from "@/components/Link";
import { DropImage } from "./DropImage";
import styles from "./styles.module.scss";

const formatPrice = (price: number | null) => {
  if (!price) return "Price on request";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
};

type Props = {
  drop: VendorDrop;
};

export const VendorSection = ({ drop }: Props) => {
  const [brokenCount, setBrokenCount] = useState(0);

  if (brokenCount >= drop.items.length) return null;

  return (
    <Box className={styles.vendorSection}>
      <Link
        href={`/search?vendors=${drop.vendorId}`}
        className={`${styles.vendorButton} ${styles.dropLink}`}
      >
        {drop.vendorName}
      </Link>

      <Box className={styles.itemsGrid}>
        {drop.items.map((item) => (
          <Link
            key={item.id}
            href={`/search/product/${item.id}`}
            className={`${styles.itemCard} ${styles.dropLink}`}
          >
            <Box className={styles.imageWrapper}>
              <DropImage
                src={item.imageurl}
                alt={item.brandname || "Product"}
                className={styles.image}
                onBroken={() => setBrokenCount((c) => c + 1)}
              />
              <Box className={styles.overlayInfo}>
                {item.brandname && (
                  <Badge className={styles.brandPill} variant="filled">
                    {item.brandname}
                  </Badge>
                )}
                <Badge className={styles.pricePill} variant="filled">
                  {formatPrice(item.priceusd || item.itemprice)}
                </Badge>
              </Box>
            </Box>
          </Link>
        ))}
      </Box>
    </Box>
  );
};
